import { render, staticRenderFns } from "./course_all copy.vue?vue&type=template&id=2e31a999"
import script from "./course_all copy.vue?vue&type=script&lang=js"
export * from "./course_all copy.vue?vue&type=script&lang=js"
import style0 from "./course_all copy.vue?vue&type=style&index=0&id=2e31a999&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports